import { render, staticRenderFns } from "./student-score-table.vue?vue&type=template&id=7f7bb498"
import script from "./student-score-table.vue?vue&type=script&lang=js"
export * from "./student-score-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports